import 'styled-components';

export interface Theme {
  colors: {
    primary: string;
    primaryDark: string;
    secondary: string;
    white: string;
    border: string;
    text: {
      primary: string;
      secondary: string;
    };
  };
  spacing: {
    xsm: string;
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xlg: string;
  };
  breakpoints: {
    mobile: string;
    tablet: string;
  };
  gradients: {
    primary: string;
    text: string;
  };
  typography: {
    fontSizes: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      xxl: string;
    };
    fontWeights: {
      normal: number;
      medium: number;
      semibold: number;
      bold: number;
    };
    lineHeights: {
      tight: number;
      normal: number;
      relaxed: number;
    };
  };
  shadows: {
    sm: string;
    md: string;
    lg: string;
  };
  borderRadius: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
    full: string;
  };
  layout: {
    maxWidth: string;
    headerHeight: string;
  };
}

export const theme: Theme = {
  colors: {
    primary: '#132450',
    primaryDark: '#0A1428',
    secondary: '#ECF6FF',
    white: '#FFFFFF',
    border: '#838383',
    text: {
      primary: '#132450',
      secondary: '#666666',
    },
  },
  spacing: {
    xsm: '0.5rem',
    xs: '0.75rem',
    sm: '1rem',
    md: '2rem',
    lg: '4rem',
    xl: '6rem',
    xlg: '12rem',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
  },
  gradients: {
    primary: 'linear-gradient(110.71deg, #1a3156 0%, #294e89 100%)',
    text: 'linear-gradient(90deg, #132450 0%, #2b52b6 100%)',
  },
  typography: {
    fontSizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '2.5rem',
    },
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.8,
    },
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px rgba(0, 0, 0, 0.05)',
    lg: '0px 4px 30px rgba(0, 0, 0, 0.05)',
  },
  borderRadius: {
    sm: '5px',
    md: '8px',
    lg: '20px',
    xl: '40px',
    full: '50%',
  },
  layout: {
    maxWidth: '1450px',
    headerHeight: '64px',
  },
};
